import {z} from "zod"

import {getJson} from "../http"

// Zod schema for the poll confirmation response
const PollConfirmationResponseSchema = z.looseObject({
	Status: z.string(),
	Next: z.string(),
})

export type PollConfirmationResponse = z.infer<typeof PollConfirmationResponseSchema>

function waitForOneSecond(): Promise<void> {
	return new Promise((resolve) => setTimeout(resolve, 1000))
}

export const pollConfirmation = async (
	paymentArrangementID: string,
	numberOfRetries: number = 0,
): Promise<PollConfirmationResponse> => {
	const result = await getJson(
		`/app/payment-arrangements/${paymentArrangementID}/status`,
		PollConfirmationResponseSchema,
	)

	if (result.Status !== "initiated" && result.Status !== "submitted") {
		return result
	}

	if (numberOfRetries === 59) {
		return result
	}

	await waitForOneSecond()
	return await pollConfirmation(paymentArrangementID, numberOfRetries + 1)
}
